import { useTranslation } from 'react-i18next';
import { UserModule } from '../api/methodsApi';
import IdentityContext from '../../../contexts/IdentityContext';
import { useContext } from 'react';
import Tooltip from '@pelckmans/elementis/components/tooltip';
import Pill from '@pelckmans/elementis/components/pill';
import Role from '../../../core/security/role';

const BASE = 'PAGES.MY_METHODS.MODULES.CARDS.STATUS';

function UserModuleStatus({ access, module, newModule }: { access: boolean; module: UserModule; newModule: boolean }) {
  const { t } = useTranslation();
  const { identity } = useContext(IdentityContext);
  const { id, publishingState, assignments, isDemo, incomplete } = module;

  const isAuthor = identity.author_modules.includes(module.id);
  const role = t(`ROLES.${isAuthor ? 'AUTHOR' : identity.highestRole.toUpperCase()}`);

  const ASSIGNMENT_BASE = `${BASE}.ASSIGNMENTS.${assignments === 1 ? 'SINGLE' : 'MULTIPLE'}`;

  return (
    <>
      {newModule && (
        <Tooltip
          key={`newmodule-${id}`}
          truncation="wrapped"
          anchor={
            <Pill tooltip prominence="success" role="status">
              {t(`${BASE}.NEW.LABEL`)}
            </Pill>
          }
        >
          {t(`${BASE}.NEW.TOOLTIP.VALUE`)}
        </Tooltip>
      )}
      {publishingState === 'preview' && (
        <Tooltip
          key={`preview-${id}`}
          truncation="wrapped"
          anchor={
            <Pill tooltip prominence="info" role="status">
              {t(`${BASE}.PREVIEW.LABEL`)}
            </Pill>
          }
        >
          {t(`${BASE}.PREVIEW.TOOLTIP.${access ? 'ACCESS' : 'NO_ACCESS'}`, { role })}
        </Tooltip>
      )}
      {publishingState === 'review' && (
        <Tooltip
          key={`review-${id}`}
          truncation="wrapped"
          anchor={
            <Pill tooltip prominence="info" role="status">
              {t(`${BASE}.REVIEW.LABEL`)}
            </Pill>
          }
        >
          {t(`${BASE}.REVIEW.TOOLTIP.VALUE`, { role })}
        </Tooltip>
      )}
      {incomplete && (
        <Tooltip
          key={`incomplete-${id}`}
          truncation="wrapped"
          anchor={
            <Pill tooltip prominence="warning" role="status">
              {t(`${BASE}.INCOMPLETE.LABEL`)}
            </Pill>
          }
        >
          {t(`${BASE}.INCOMPLETE.TOOLTIP.VALUE`, { role })}
        </Tooltip>
      )}
      {isDemo && (
        <Tooltip
          key={`demo-${id}`}
          truncation="wrapped"
          anchor={
            <Pill tooltip prominence="danger" role="status">
              {t(`${BASE}.DEMO.LABEL`)}
            </Pill>
          }
        >
          {t(`${BASE}.DEMO.TOOLTIP.VALUE`, { role })}
        </Tooltip>
      )}
      {assignments >= 1 && identity.highestRole === Role.STUDENT && (
        <Tooltip
          key={`assignments-${id}`}
          truncation="wrapped"
          anchor={
            <Pill tooltip role="status">
              {t(`${ASSIGNMENT_BASE}.LABEL`, { amount: assignments })}
            </Pill>
          }
        >
          {t(`${ASSIGNMENT_BASE}.TOOLTIP.VALUE`, { amount: assignments })}
        </Tooltip>
      )}
    </>
  );
}

export default UserModuleStatus;
